import N8nSelect from './Select.vue';

export default N8nSelect;
